<template>
    <div>
        <ul>
            <BetBuilderSelection
                v-for="item in selections"
                v-bind:key="item.id"
                v-bind:selection="item"
                v-bind:event="event"
            />
        </ul>
        <div v-if="isShowExpandToggle" class="card_content_more">
            <VButton
                v-gtm:label="gtmLabel"
                v-gtm:@click
                v-on:click="emit('toggleExpand')"
            >
                {{ expandButton }}
                <SboIcon
                    name="system:arrowDown"
                    size="14"
                    v-bind:rotated="isExpanded"
                />
            </VButton>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue';
    import BetBuilderSelection from '@/components/betBuilderRecommendation/BetBuilderSelection.vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import VButton from '@/components/common/button/VButton.vue';
    import { i18n } from '@/core/lib/i18n';
    import type { IEvent } from '@/interface/IEvent';
    import type { IBetBuilderCombinationSelection } from '@/interface/betBuilder';

    const props = defineProps<{
        selections: IBetBuilderCombinationSelection[];
        event: IEvent;
        isShowExpandToggle: boolean;
        isExpanded: boolean;
    }>();

    const emit = defineEmits<{
        toggleExpand: [];
    }>();

    const expandButton = computed(() => (props.isExpanded ? i18n.t('cta_show_less') : i18n.t('cta_show_more')));
    const gtmLabel = computed(() => (props.isExpanded ? 'Colps' : 'Expd'));
</script>

<style lang="scss" scoped>
    @import "@/components/betBuilderRecommendation/BetBuilderRecommendation";
</style>
